import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { Customer } from 'src/app/interfaces/customer';
import { AuditService } from 'src/app/services/audit.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-audit-dashboard',
    templateUrl: './audit-dashboard.component.html',
    styleUrls: ['./audit-dashboard.component.scss'],
    standalone: false
})
export class AuditDashboardComponent {
  userProfile?: UserProfile;
  customer?: Customer = {};
  companyType: string = '';
  auditTransactions: any = {};
  showPenaltyDescription: boolean = false;
  useMockData: boolean = false;
  isLoading = false;
  isUploading = false;
  loadingPayment: boolean = false;
  showFaxOrUploadModal: boolean = false;
  showResubmitModal: boolean = false;
  showUploadModal: boolean = false;
  submittalType: string = "";
  currentTrans: any = {};
  username: string = '';
  auditPenaltyStatus: any = {};
  pdfUrl: string = "";
  spanish: boolean = false;
  french: boolean = false;
  allowDocumentSubmissionContinue = false;
  isValidFileType: boolean = true;
  invFileTypeModal: any;

  get transactions() {
      return this.auditTransactions;
  }

  get currentTransaction() {
      return this.currentTrans;
  }

  get penaltyStatus() {
      return this.auditPenaltyStatus;
  }

  @ViewChild('FaxOrUploadModal') faxOrUploadModal: ElementRef | undefined;
  @ViewChild('UploadModal') uploadModal: ElementRef | undefined;
  @ViewChild('ResubmitModal') resubmitModal: ElementRef | undefined;
  @ViewChild('InvalidFileTypeModal') invalidFileTypeModal: ElementRef | undefined;

  constructor(private generalService: GeneralService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private auditService: AuditService,
    private translatorService: TranslatorService,
    private modalService: NgbModal) { }


  ngOnInit(): void {
      this.authenticationService.setDeepLinkResolved(true);
      this.authenticationService.setDeepLink('');
      window.onbeforeunload = null;
      this.isLoading = true;
      this.username = this.authenticationService.getUserName();
      this.userProfile = this.authenticationService.getUserProfile();
      this.customer = this.userProfile!.customer;

      this.auditPenaltyStatus = this.auditService.getCustomerAuditPenaltyStatus();
      
      if (this.useMockData) {
          this.auditTransactions = this.auditService.mockGetAuditTransactions();
          this.isLoading = false;
      } else {
          this.loadAuditTransactions();
      }     
      
      if (!this.userProfile!.customerId || this.userProfile!.customerId === '2147483647' || !this.userProfile!.customer) {
          this.router.navigateByUrl('/accessDenied');
      }

      // This one is for you Danny...
      this.companyType = this.customer.customerType === 1 ?
          'MC' :
            this.customer.customerType === 6 ?
          'ISP' :
            '';

      this.scrollToTop();

      document.getElementById('onlineSubmittalType')?.focus();
  }

  loadAuditTransactions() {
      this.auditService.auditFiles = [];
      const auditServicePromise = this.auditService.getAuditTransactions();
      auditServicePromise.then((result: any | any) => {
          if (result.auditTransactions) {
              this.auditTransactions = result.auditTransactions;
              this.currentTrans = this.auditTransactions.find((tran: any) => tran.authCode === this.currentTransaction.authCode);
          } else {
              this.auditTransactions = [];
          }
          
          this.isLoading = false;
          this.isUploading = false;
      });
  }

  openSubmitDialog(transaction: any) {
      this.currentTrans = transaction;
      this.showFaxOrUploadModal = true
      this.modalService.open(this.faxOrUploadModal, { ariaLabelledBy: 'faxOrUploadModalTitle' });
  }

  openReSubmitDialog(transaction: any) {
      this.currentTrans = transaction;
      this.showResubmitModal = true;
      this.modalService.open(this.resubmitModal, { ariaLabelledBy: 'resubmitModalTitle' });
  }

  cancelResubmitModal() {
    this.modalService.dismissAll();
  }

  continueWithResubmit() {
      this.isLoading = true;
      // remove existing documents
      this.currentTrans.documents.forEach((doc: any) => {
          this.removeDocument(doc.documentId, this.currentTrans.authCode, false);
      });
      this.currentTrans.documents = [];
      this.isLoading = false;
      this.showResubmitModal = false;
      this.showFaxOrUploadModal = true;
      this.modalService.open(this.faxOrUploadModal, { ariaLabelledBy: 'faxOrUploadModalTitle' });
  }
  
    removeDocument(docId: string, authCode: string, reload: boolean) {
        this.auditService.removeDocument(docId, this.currentTrans.authCode)
            .then((result: any) => {
                console.log(result)
                if (result && result === 'success') {
                    if (reload) {
                        this.loadAuditTransactions();
                    }
                } else {
                    console.error('Document deleted failed. Reason: ' + result);
                    this.scrollToTop();
                    this.modalService.dismissAll();
                    this.router.navigateByUrl('/applicationException');
                }
            }).catch((error: any) => {
                console.error(error);
                this.router.navigateByUrl('/applicationException');
            });
    }

  selectFaxOrUpload() {
      this.modalService.dismissAll();
      this.showFaxOrUploadModal = false;
      this.allowDocumentSubmissionContinue = false;

      if (this.submittalType === 'online') {
          this.showUploadModal = true;
          this.submittalType = '';
          this.modalService.open(this.uploadModal, { size: 'lg', ariaLabelledBy: 'uploadModalTitle' });
          // wait 0.5 seconds and then set focus on the file input
            setTimeout(() => {
                if(this.modalService.hasOpenModals()){
                    document.getElementById('uploadDocumentsId')?.focus();
                }
            }, 500);
      } else {
          this.isLoading = true;
          this.submittalType = '';
          const auditServicePromise = this.auditService.getFaxCoverSheet(this.currentTrans.authCode);
          auditServicePromise.then((result: any | any) => {
            this.isLoading = false;
            const htmlContent  = result.data;
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const faxWindow = window.open(url, '_blank', 'width=800,height=800,scrollbars=yes,resizable=yes');
            if (faxWindow) {
                faxWindow.onload = () => {
                    URL.revokeObjectURL(url);
                };
                faxWindow?.focus();
            } else {
                // If popup blocked
                console.warn('Popup blocked. Please allow popups for this site.');
                URL.revokeObjectURL(url); // Revoke even if not opened to prevent memory leaks
            }
          })
          .catch((error: any) => {
              console.error(error);
          });
          this.isLoading = false;
      }
  }

  cancelFaxOrUploadModal() {
      this.modalService.dismissAll();
      this.allowDocumentSubmissionContinue = false;
      this.submittalType = '';
      this.showFaxOrUploadModal = false;
  }

  closeUploadModal() {
      this.currentTrans = {};
      this.showUploadModal = false;
      this.modalService.dismissAll();
  }

  cancelUploads() {
      //if the upload modal is dismissed in this way we must remove the documents that may have been uploaded
      this.isLoading = true;
      
      this.currentTrans.documents.forEach((doc: any) => {
          this.auditService.removeDocument(doc.documentId, this.currentTrans.authCode);
      });
      this.currentTrans.documents = [];

      this.isLoading = false;
      this.closeUploadModal();
  }

  completeDocumentUploads() {
      this.isLoading = true;
      const auditServicePromise = this.auditService.incrementUploadAttempts(this.currentTrans.authCode);
      auditServicePromise.then((updatedRecordCount: number | any) => {
          this.loadAuditTransactions();
      }).catch((error: any) => {
          console.error(error);
      });
      
      this.closeUploadModal();
  }

  isSubmitDisabled(){
    var disabled = true;
    if (this.currentTrans && this.currentTrans.documents && this.currentTrans.documents.length > 0){
        disabled = false;
    }
    return disabled;
  }

  showDocument(documentId: string) {
      this.generalService.logActivity('audit_document::view', this.username,
        [{ name: 'document_id', value: documentId}], null);
      const docUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
      window.open(docUrl, '', 'width=800,height=600,resizable=1');
  }

  uploadDocuments(event: any) {
    console.log(event);
      if (event.target && event.target.files && event.target.files.length > 0) {
          Array.from(event.target.files).forEach((file:any) => {
              if (file.name) {
                  const nameParts: string[] = file.name.split('.');
                  const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                  if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                      this.isValidFileType = true;
                      this.auditService.auditFiles.push(file);
                  } else {
                      this.isValidFileType = false;
                      this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                      event.target.value = '';
                      return;
                  }
              }
          });
      } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
          Array.from(event.dataTransfer.files).forEach((file:any) => {
              if (file.name) {
                  const nameParts: string[] = file.name.split('.');
                  const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                  if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                      this.isValidFileType = true;
                      this.auditService.auditFiles.push(file);
                  } else {
                      this.isValidFileType = false;
                      this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                      event.target.value = '';
                      return;
                  }
              }
          });
      } else {
           // no files. User may have cancelled out of file windows file explorer when selecting file.
           event.target.value = '';
           return;
      }

      if (this.isValidFileType) {
          this.isUploading = true;
          this.auditService.uploadAuditDocuments(this.currentTrans.authCode, this.username)
              .then((result: any) => {
                  if (!result) {
                      console.error('Audit document upload error.');
                      event.target.value = '';
                      this.router.navigateByUrl('/applicationException');
                  } else if (result && result === 'unauthorized') {
                      console.error('User not authorized to upload audit documents.');
                      event.target.value = '';
                      this.router.navigateByUrl('/accessDenied');
                  } else if (result) {
                      event.target.value = '';
                      this.loadAuditTransactions();
                  }
              }).catch((error: any) => {
                  console.error('Error uploading audit documents');
                  console.error(error);
                  event.target.value = '';
              });
      } else {
           event.target.value = '';
      }
  }

  closeInvalidFileTypeModal() {
    this.isValidFileType = true;
    this.invFileTypeModal.close();
  }

  onFileUpload(event: any) {
      if (event.target && event.target.files && event.target.files.length > 0) {
          event.target.files.forEach((element:any) => {
              this.auditService.auditFiles.push(element);
          });
      } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
          event.dataTransfer.files.forEach((element:any) => {
              this.auditService.auditFiles.push(element);
          });
      }
  }

  submittalTypeChanged(type: string) {
    this.submittalType = type;
      this.allowDocumentSubmissionContinue = true;
  }

  translateStates(statesVal:string):string{
      const lang = this.translatorService.getActiveLanguage().toUpperCase();
      let retVal:string = statesVal;
      switch (statesVal){
          case "Open":
              retVal = (lang === "EN" ? "Open" : (lang === "ES" ? "Abierto" : "Ouvrir"));
              break;
          case "Close":
              retVal = (lang === "EN" ? "Close" : (lang === "ES" ? "Cerrar" : "Close"));
              break;
          case "Called":
              retVal = (lang === "EN" ? "Called" : (lang === "ES" ? "Llamado" : "Appelé"));
              break;
          case "Acknowledged":
              retVal = (lang === "EN" ? "Acknowledged" : (lang === "ES" ? "Reconocido" : "Reconnu"));
              break;
          case "In Process":
              retVal = (lang === "EN" ? "In Process" : (lang === "ES" ? "Procesado" : "En processus"));
              break;
          case "Accepted":
              retVal = (lang === "EN" ? "Accepted" : (lang === "ES" ? "Aceptado" : "Accepté"));
              break;
          case "Not Accepted":
              retVal = (lang === "EN" ? "Not Accepted" : (lang === "ES" ? "No fue aceptado" : "Pas été accepté"));
              break;
      }
      return  retVal

  }

  scrollToTop() {
      window.scrollTo(0, 0);
  } 

  openDocument(docName: string) {
      this.generalService.openDocument(docName);
  }

}
